import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';
import {CheckoutResponse, ExpertPaymentStatus} from '@models/expert-payment.interface';

@Injectable({
  providedIn: 'root',
})
export class ExpertPaymentService {

  private readonly BASE_URL = environment.apiUrl + '/stripe/expert-payment';

  constructor(private http: HttpClient) {}

  checkExpertPayment(): Observable<ExpertPaymentStatus> {
    return this.http.get<ExpertPaymentStatus>(this.BASE_URL + '/status', {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  createExpertPaymentCheckout(): Observable<CheckoutResponse> {
    return this.http.post<CheckoutResponse>(this.BASE_URL + '/checkout', {}, {
      headers: getDefaultHttpHeaders().headers,
    });
  }
}
